import online from "../../../assets/imgs/online.gif";
import offline from "../../../assets/imgs/offline.gif";
import "./profile.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Scrollto from "../../tools/scrollTo";
import { useNavigate } from "react-router-dom";
import PanelFrame from "../../ui/PanelFrame";
import SiteButton from "../../ui/SiteButton";
import { useLang } from "../../../i18n/LangContext";

const Profile = () => {
  const matches = useMediaQuery("(max-width:500px)");
  const { t } = useLang();

  const user = useSelector((state) => state.reducerUser.userLogin.data);
  const [userFromComp, setUserFromComp] = useState();
  const [username, setUsername] = useState();
  const [players, setPlayers] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    const { data, username: uname } = user;
    setUsername(uname);
    setUserFromComp(data?.[0]);
    setPlayers(data?.[1]);
  }, [user]);

  const isBanned = userFromComp?.bloc_code == 1;
  const isOnline = userFromComp?.status == 1;
  const charCount = players?.players?.length ?? 0;
  const bcoin = userFromComp?.BCoin ?? 0;
  const credits = userFromComp?.Credits ?? 0;

  const rows = [
    {
      label: t("account_status"),
      value: (
        <span
          className={
            isBanned
              ? "mu-account__badge mu-account__badge--banned"
              : "mu-account__badge mu-account__badge--active"
          }
        >
          {isBanned ? t("banned") : t("active")}
        </span>
      ),
    },
    { label: t("username"), value: username || "—" },
    {
      label: t("password"),
      value: (
        <div className="mu-account__pass-row">
          <span>••••••••</span>
          <SiteButton
            variant="ghost"
            className="mu-account__mini-btn"
            onClick={() => navigate("/player/changePassword")}
          >
            {t("change_password")}
          </SiteButton>
          <SiteButton
            variant="ghost"
            className="mu-account__mini-btn"
            onClick={() => navigate("/player/changeEmail")}
          >
            {t("change_email")}
          </SiteButton>
        </div>
      ),
    },
    {
      label: t("online_status"),
      value: (
        <span className="mu-account__online">
          <img src={isOnline ? online : offline} alt="" />
          {isOnline ? t("online") : t("offline")}
        </span>
      ),
    },
    { label: t("characters"), value: String(charCount) },
    {
      label: "BCoin",
      value: <strong className="mu-account__credits">{bcoin}</strong>,
    },
    {
      label: "Credits",
      value: <strong className="mu-account__credits">{credits}</strong>,
    },
  ];

  return (
    <div className="mu-account">
      <Scrollto position={matches ? 311 : 200} />
      <PanelFrame title={t("my_account")}>
        <ul className="mu-account__list">
          {rows.map((row) => (
            <li key={row.label}>
              <span className="mu-account__label">{row.label}</span>
              <div className="mu-account__value">{row.value}</div>
            </li>
          ))}
        </ul>
        <div className="mu-account__actions">
          <SiteButton variant="secondary" to="/players">
            {t("my_characters")}
          </SiteButton>
          <SiteButton variant="primary" to="/buyCredits">
            {t("buy_bcoin")}
          </SiteButton>
          <SiteButton variant="secondary" to="/vote">
            {t("vote_now")}
          </SiteButton>
          {/* TEMPORARILY DISABLED — SEND CREDITS BUTTON
              Restore together with the Send Credits component.
          <SiteButton variant="secondary" to="/sendCredits">
            Send Credits
          </SiteButton>
          */}
        </div>
      </PanelFrame>
    </div>
  );
};

export default Profile;
